import React from 'react';
import {
  useTable,
  useGlobalFilter,
  useSortBy,
  usePagination,
} from 'react-table';
import 'bootstrap/dist/css/bootstrap.min.css';
function GlobalFilter({ preGlobalFilteredRows, globalFilter, setGlobalFilter }) {
  const count = preGlobalFilteredRows.length;
  return (
    <div className="mb-4">
      <input
        type="text"
        className="form-control"
        value={globalFilter || ''}
        onChange={e => setGlobalFilter(e.target.value || undefined)}
        placeholder={`Search ${count} records...`}
      />
    </div>
  );
}

const exportToCSV = (columns, data, fileName = 'table-data.csv') => {
  if (!data.length) return;

  // Get headers from react-table columns
  const headers = columns.map(col => col.Header);

  // Get accessor values
  const rows = data.map(row =>
    columns.map(col => {
      const value =
        typeof col.accessor === 'function'
          ? col.accessor(row)
          : row[col.accessor];
      return `"${value ?? ''}"`;
    })
  );

  const csvContent =
    [headers.join(','), ...rows.map(r => r.join(','))].join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


const AdminTable = ({ tableHeaders = [], tableData = [] }) => {
  const data = React.useMemo(
    () => (tableData.length ? tableData : []),
    [tableData] 
  );

  const columns = React.useMemo(
    () => (tableHeaders.length ? tableHeaders : []),
    [tableHeaders] 
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    
    prepareRow,
    state,
    preGlobalFilteredRows,
    setGlobalFilter,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    nextPage,
    previousPage,
    setPageSize,
  } = useTable(
    { columns, data, initialState: { pageSize: 10 } },
    useGlobalFilter, // Use global filter
    useSortBy, // Use sorting
    usePagination // Use pagination
  );

  return (
    <div className="container-fluid mt-5 ">
      {/* Search Input */}

      <div className='row'>

        <div className='col-md-10'>
                <GlobalFilter
        preGlobalFilteredRows={preGlobalFilteredRows}
        globalFilter={state.globalFilter}
        setGlobalFilter={setGlobalFilter}
      />
        </div>
        <div className='col-md-2 text-right'>
                <button
    className="btn btn-success w-100"
    onClick={() => exportToCSV(columns, data)}
  >
    Export CSV
  </button>
        </div>
      </div>
   




      {/* Table */}
      <div className="table-responsive ">
        <table {...getTableProps()} className="table table-bordered table-hover table-striped">
          <thead className="thead-dark">
            {headerGroups.map((headerGroup, index) => (
              <tr {...headerGroup.getHeaderGroupProps()} key={index}>
                {headerGroup.headers.map((column, colIndex) => (
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    key={colIndex}
                    className="text-center"
                  >
                    {column.render('Header')}
                    <span>
                      {column.isSorted
                        ? column.isSortedDesc
                          ? ' 🔽'
                          : ' 🔼'
                        : ''}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()} key={i}>
                  {row.cells.map((cell, cellIndex) => (
                    <td
                      {...cell.getCellProps()}
                      key={cellIndex}
                      className="text-center"
                    >
                      {cell.render('Cell')}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Pagination Controls */}
      <div className="d-flex justify-content-between align-items-center mt-3">
        <div>
          <button
            className="btn-lg border-0 previousbtn"
            onClick={() => previousPage()}
            disabled={!canPreviousPage}
          >
            Previous
          </button>
          <button
            className="btn-lg border-0 nextbtn ml-2"
            onClick={() => nextPage()}
            disabled={!canNextPage}
          >
            Next
          </button>
        </div>
        <span>
          Page{' '}
          <strong>
            {state.pageIndex + 1} of {pageOptions.length}
          </strong>{' '}
        </span>
        <div>
          <select
            className="form-control previousbtn"
            value={state.pageSize}
            onChange={e => setPageSize(Number(e.target.value))}
            style={{ width: '105px' }}
          >
            {[5, 10, 20].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default AdminTable;
